import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Tooltip } from '../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { MAX_SUB_FOLDER_COUNT } from '../../../../DocumentVault.meta';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { CreateFolder } from '../../../CreateFolder/CreateFolder';
import { useBreadcrumbsItems } from '../../../../hooks/useBreadcrumbsItems';
import { BrowserHeaderActionsLoading } from '../../BrowserHeaderActions.loading';
import { useListEntitiesQuery } from '../../../../api/useListEntitiesQuery';
import { useDropzoneOptions } from '../../../../hooks/useDropzoneOptions';
import { useIsFolderReadOnly } from '../../../../hooks/useIsFolderReadOnly';
import { useRouteParams } from '../../../../hooks/useRouteParams';

export const BaseActions = () => {
  const isFolderReadOnly = useIsFolderReadOnly();

  const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);

  const { clientId, path, providerType, filterableByYear } = useRouteParams();
  const { isLoading, isError } = useListEntitiesQuery({
    clientId,
    path,
    providerType,
    filterableByYear,
  });

  const breadcrumbsItems = useBreadcrumbsItems();

  const canCreateFolder = breadcrumbsItems.length <= MAX_SUB_FOLDER_COUNT;

  const dropzoneOptions = useDropzoneOptions();

  const { getInputProps, open } = useDropzone(dropzoneOptions);

  if (isFolderReadOnly) {
    return null;
  }

  if (isLoading) {
    return <BrowserHeaderActionsLoading />;
  }

  if (isError) {
    return null;
  }

  return (
    <>
      <input {...getInputProps()} aria-label="Drop Zone" />

      <Tooltip
        content={`You have reached the maximum sub folder limit of ${MAX_SUB_FOLDER_COUNT} folders`}
        disabled={canCreateFolder}
      >
        {/* We need the span because a disabled button does not trigger the tooltip */}
        <span>
          <Button
            leftIcon="far fa-plus-circle"
            variant="secondary"
            onClick={() => setIsCreateFolderModalOpen(true)}
            disabled={!canCreateFolder}
          >
            New Folder
          </Button>
        </span>
      </Tooltip>

      <Button onClick={open} leftIcon="far fa-arrow-circle-up" variant="secondary">
        Upload
      </Button>

      {isCreateFolderModalOpen && (
        <CreateFolder onClose={() => setIsCreateFolderModalOpen(false)} />
      )}
    </>
  );
};
